/**
 * Explainer Accordion Module
 * Handles accordion functionality for explainer blocks
 */

class ExplainerAccordion {
	constructor() {
		this.accordions = [];
		this.init();
	}

	init() {
		// Find all explainer blocks and initialize accordions
		const explainerBlocks = document.querySelectorAll('.explainer-block');
		explainerBlocks.forEach((block, blockIndex) => {
			this.initializeAccordion(block, blockIndex);
		});
	}

	initializeAccordion(block, blockIndex) {
		const accordionItems = block.querySelectorAll('.explainer-accordion-item');
		
		accordionItems.forEach((item, itemIndex) => {
			const trigger = item.querySelector('.explainer-accordion-header');
			const content = item.querySelector('.explainer-accordion-content');
			
			if (trigger && content) {
				// Add click event listener
				trigger.addEventListener('click', (e) => {
					e.preventDefault();
					this.toggleAccordion(item, content);
				});

				// Store reference
				this.accordions.push({
					block: block,
					item: item,
					trigger: trigger,
					content: content,
					isOpen: false
				});
			}
		});
	}

	toggleAccordion(item, content) {
		const isOpen = item.classList.contains('is-open');
		
		if (isOpen) {
			// Close accordion
			this.closeAccordion(item, content);
		} else {
			// Open accordion
			this.openAccordion(item, content);
		}
	}

	openAccordion(item, content) {
		// Add open class
		item.classList.add('is-open');
		
		// Set max-height for smooth animation
		const scrollHeight = content.scrollHeight;
		content.style.maxHeight = scrollHeight + 'px';
		
		// Update stored state
		const accordion = this.accordions.find(acc => acc.item === item);
		if (accordion) {
			accordion.isOpen = true;
		}
	}

	closeAccordion(item, content) {
		// Remove open class
		item.classList.remove('is-open');
		
		// Reset max-height
		content.style.maxHeight = '0px';
		
		// Update stored state
		const accordion = this.accordions.find(acc => acc.item === item);
		if (accordion) {
			accordion.isOpen = false;
		}
	}

	// Public method to open specific accordion
	openAccordionByIndex(blockIndex, itemIndex) {
		const accordion = this.accordions.find(acc => 
			acc.block.dataset.blockIndex == blockIndex && 
			acc.item.dataset.accordionItem == itemIndex
		);
		
		if (accordion && !accordion.isOpen) {
			this.openAccordion(accordion.item, accordion.content);
		}
	}

	// Public method to close all accordions in a block
	closeAllInBlock(blockIndex) {
		const blockAccordions = this.accordions.filter(acc => 
			acc.block.dataset.blockIndex == blockIndex
		);
		
		blockAccordions.forEach(accordion => {
			if (accordion.isOpen) {
				this.closeAccordion(accordion.item, accordion.content);
			}
		});
	}
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	window.explainerAccordion = new ExplainerAccordion();
});

// Re-initialize if new content is loaded dynamically
document.addEventListener('explainer-accordion-refresh', () => {
	if (window.explainerAccordion) {
		window.explainerAccordion.init();
	}
});

export default ExplainerAccordion;
